import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from '@1c/ui';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import useApplicationAllowedBanks from 'src/dataHooks/useApplicationAllowedBanks';
import RaiffeisenBank from './customization/RaiffeisenBank';
import AlfaBank from './customization/AlfaBank';
import Form from './Form';
import styles from './styles.module.scss';

const customizations: any = {
  raiffeisen: RaiffeisenBank,
  'dcf1e23a-1757-4a62-8138-245211a40ad6': AlfaBank,
};

const BankApplication: React.FC = () => {
  const { bankUeid } = useParams();
  const { fetchAllowedBanks, isAllowedBanksLoading, allowedBanks } = useApplicationAllowedBanks();
  
  const bank = useMemo(() => {
    return (allowedBanks?.partnerBanks || []).find((bank: any) => bank.ueid === bankUeid);
  }, [allowedBanks]);
  
  useEffect(() => {
    fetchAllowedBanks();
  }, []);
  
  const Content = customizations[bank?.islMemberId?.toLowerCase()] || customizations[bank?.ueid] || Form;
  
  return (
    <ContentLayout size="small">
      <Text type="h2" className={styles['title']}>Заявка на подключение к Системе быстрых платежей</Text>
      {isAllowedBanksLoading ? (
        <Spin size={60} className={styles['spin']} />
      ) : (
        <Content allowedBanks={allowedBanks} />
      )}
    </ContentLayout>
  );
};

export default BankApplication;
